import { render, staticRenderFns } from "./AdobePdfReaderViewer.vue?vue&type=template&id=781bb4cc&scoped=true&"
import script from "./AdobePdfReaderViewer.vue?vue&type=script&lang=js&"
export * from "./AdobePdfReaderViewer.vue?vue&type=script&lang=js&"
import style0 from "./AdobePdfReaderViewer.vue?vue&type=style&index=0&id=781bb4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781bb4cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781bb4cc')) {
      api.createRecord('781bb4cc', component.options)
    } else {
      api.reload('781bb4cc', component.options)
    }
    module.hot.accept("./AdobePdfReaderViewer.vue?vue&type=template&id=781bb4cc&scoped=true&", function () {
      api.rerender('781bb4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/FileViewers/AdobePdfReaderViewer.vue"
export default component.exports